<template>
  <div>
    <navigation />
    <div class="stat-container">
      <div style="padding: 6px 12px 30px 0px">
        <button class="hollow-btn" @click="showTask = true">任务列表</button>
        <button @click="getStatSalary()" style="margin-left: 0px">标注统计</button>
        <button v-if="role === 'admin'" @click="getStatCat()" style="margin-left: 0px">类别统计</button>
        <button v-if="role === 'admin'" @click="getTaskClass" style="margin-left: 0px">图片统计</button>
        <span v-if="role === 'admin' && !showTask && listTab === 'task'">
          <JsonExcel
            :before-generate="exportData"
            :data="jsonData"
            :fields="fields[adminTab]"
            :name="excelName"
            style="display:inline-block;"
          >
            <button>导出Excel</button>
          </JsonExcel>
        </span>
        <button v-if="role === 'admin' || role === 'approver'" @click="toRank()" style="margin: 0px;float: right;">
          排行榜
        </button>
      </div>
      <el-row :gutter="20" v-if="showTask">
        <el-col :span="3">
          <el-input prefix-icon="el-icon-search" placeholder="任务名" v-model="taskName" clearable @change="filterTask">
          </el-input>
        </el-col>
        <el-col :span="4">
          <el-select v-model="taskStatusList" multiple collapse-tags placeholder="任务状态">
            <el-option v-for="(value, key) in taskStatusMap" :key="key" :label="value" :value="key"> </el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-date-picker
            v-model="timeRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-col>
        <button style="float: right" @click="filterTask">
          检索
        </button>
      </el-row>
      <div class="task-info" v-if="showTask">
        <table width="100%" class="table">
          <thead>
            <tr>
              <th>
                <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange"
                  >全选{{ taskIds.length ? `(${taskIds.length})` : '' }}</el-checkbox
                >
              </th>
              <th>任务ID</th>
              <th>任务名</th>
              <th>创建时间</th>
              <th>任务状态</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="task of filterTaskList" :key="`task${task.id}`">
              <td>
                <input
                  type="checkbox"
                  v-model="taskIds"
                  :value="task.id"
                  style="vertical-align: middle;margin-right: 8px;"
                  @change="handleCheckedTaskChange"
                />
              </td>
              <td>{{ task.id }}</td>
              <td>{{ task.name }}</td>
              <td>{{ createDate(task.createAt) }}</td>
              <td>{{ taskStatusMap[task.status] }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-if="listTab === 'task' && !showTask">
        <div v-if="role === 'admin' && !showTask">
          <select v-model="adminTab">
            <option value="anno">标注员</option>
            <option value="appr1">审核员</option>
            <option value="appr2">安检员</option>
          </select>
        </div>

        <div v-if="role !== 'admin' && statTaskList && statTaskList.length > 0 && !showTask" style="overflow: scroll;">
          <table width="100%" class="table">
            <thead>
              <tr v-if="role === 'annotator'">
                <th>任务名</th>
                <th>正确框数</th>
                <th>错误框数</th>
                <th>多框数</th>
                <th>漏框数</th>
                <th>申诉成功</th>
                <th>申诉失败</th>
                <th>无框图数</th>
                <th>薪资(元)</th>
                <th>准确率</th>
              </tr>
              <tr v-if="role === 'approver'">
                <th>任务名</th>
                <th>正确框数</th>
                <th>修改框数</th>
                <!--                <th>添加&删除框数</th>-->
                <!--                <th>错误框数</th>-->
                <th>漏框</th>
                <th>改框错误</th>
                <th>申诉成功</th>
                <th>申诉失败</th>
                <th>无框图数</th>
                <th>准确率</th>
              </tr>
              <tr v-if="role === 'approverTwo'">
                <th>任务名</th>
                <th>正确框数</th>
                <th>修改框数</th>
                <!--                <th>添加&删除框数</th>-->
                <!--                <th>错误框数</th>-->
                <th>漏框</th>
                <th>改框错误</th>
                <th>无框图数</th>
                <th>薪资(元)</th>
                <th>准确率</th>
              </tr>
            </thead>
            <tbody v-if="role === 'annotator'">
              <tr v-for="(t, index) of statTaskList" :key="`task${t.id}-${index}`">
                <td>{{ t.taskName }}</td>
                <td>{{ t.correctAnnoCount }}</td>
                <td>{{ t.wrongAnnoCount }}</td>
                <td>{{ t.unnecessaryAnnoCount }}</td>
                <td>{{ t.omittedAnnoCount }}</td>
                <td>{{ t.appealSuccessCount }}</td>
                <td>{{ t.appealRejectCount }}</td>
                <td>{{ t.uselessImageCount }}</td>
                <td>{{ annotatorSalary(t) }}</td>
                <td>
                  {{
                    precisionFormat(
                      t.correctAnnoCount /
                        (t.correctAnnoCount + t.wrongAnnoCount + t.unnecessaryAnnoCount + t.omittedAnnoCount),
                    )
                  }}
                </td>
              </tr>
            </tbody>
            <tbody v-if="role === 'approver'">
              <tr v-for="(t, index) of statTaskList" :key="`task${t.id}-${index}`">
                <td>{{ t.taskName }}</td>
                <td>{{ t.correctAnnoCount }}</td>
                <td>{{ t.updatedAnnoCount + t.addedOrDeletedAnnoCount }}</td>
                <!--                <td>{{ t.addedOrDeletedAnnoCount }}</td>-->
                <!--                <td>{{ t.wrongAnnoCount }}</td>-->
                <td>{{ t.wrongOmitAnnoCount }}</td>
                <td>{{ t.wrongAnnoCount - t.wrongOmitAnnoCount }}</td>
                <td>{{ t.appealSuccessCount }}</td>
                <td>{{ t.appealRejectCount }}</td>
                <td>{{ t.uselessImageCount }}</td>
                <td>
                  {{
                    precisionFormat(
                      (t.correctAnnoCount + t.updatedAnnoCount + t.addedOrDeletedAnnoCount) /
                        (t.correctAnnoCount + t.updatedAnnoCount + t.addedOrDeletedAnnoCount + t.wrongAnnoCount),
                    )
                  }}
                </td>
              </tr>
            </tbody>
            <tbody v-if="role === 'approverTwo'">
              <tr v-for="(t, index) of statTaskList" :key="`task${t.id}-${index}`">
                <td>{{ t.taskName }}</td>
                <td>{{ t.correctAnnoCount }}</td>
                <td>{{ t.updatedAnnoCount + t.addedOrDeletedAnnoCount }}</td>
                <!--                <td>{{ t.addedOrDeletedAnnoCount }}</td>-->
                <!--                <td>{{ t.wrongAnnoCount }}</td>-->
                <td>{{ t.wrongOmitAnnoCount }}</td>
                <td>{{ t.wrongAnnoCount - t.wrongOmitAnnoCount }}</td>
                <td>{{ t.uselessImageCount }}</td>
                <td>{{ approverTwoSalary(t) }}</td>
                <td>
                  {{
                    precisionFormat(
                      (t.correctAnnoCount + t.updatedAnnoCount + t.addedOrDeletedAnnoCount) /
                        (t.correctAnnoCount + t.updatedAnnoCount + t.addedOrDeletedAnnoCount + t.wrongAnnoCount),
                    )
                  }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          v-if="
            role === 'admin' &&
              (statListAdmin.annotators || statListAdmin.approverOnes || statListAdmin.approverTwos) &&
              !showTask
          "
          style="overflow: scroll;"
        >
          <table width="100%" class="table">
            <thead v-if="adminTab === 'anno'">
              <tr>
                <th>用户名</th>
                <th>角色</th>
                <th>正确框数</th>
                <th>错误框数</th>
                <th>多框数</th>
                <th>漏框数</th>
                <th>申诉成功</th>
                <th>申诉失败</th>
                <th>无框图数</th>
                <th>准确率</th>
              </tr>
            </thead>
            <tbody v-if="adminTab === 'anno'">
              <tr>
                <td>总计</td>
                <td>标注员</td>
                <td>{{ sumCalc(statListAdmin.annotators, 'correctAnnoCount') }}</td>
                <td>{{ sumCalc(statListAdmin.annotators, 'wrongAnnoCount') }}</td>
                <td>{{ sumCalc(statListAdmin.annotators, 'unnecessaryAnnoCount') }}</td>
                <td>{{ sumCalc(statListAdmin.annotators, 'omittedAnnoCount') }}</td>
                <td>{{ sumCalc(statListAdmin.annotators, 'appealSuccessCount') }}</td>
                <td>{{ sumCalc(statListAdmin.annotators, 'appealRejectCount') }}</td>
                <td>{{ sumCalc(statListAdmin.annotators, 'uselessImageCount') }}</td>
                <td>
                  {{
                    precisionFormat(
                      sumCalc(statListAdmin.annotators, 'correctAnnoCount') /
                        (sumCalc(statListAdmin.annotators, 'correctAnnoCount') +
                          sumCalc(statListAdmin.annotators, 'wrongAnnoCount') +
                          sumCalc(statListAdmin.annotators, 'unnecessaryAnnoCount') +
                          sumCalc(statListAdmin.annotators, 'omittedAnnoCount')),
                    )
                  }}
                </td>
              </tr>
              <tr v-for="(t, index) of statListAdmin.annotators" :key="`task${t.id}-${index}`">
                <td>{{ t.userName }}</td>
                <td>标注员</td>
                <td>{{ t.correctAnnoCount }}</td>
                <td>{{ t.wrongAnnoCount }}</td>
                <td>{{ t.unnecessaryAnnoCount }}</td>
                <td>{{ t.omittedAnnoCount }}</td>
                <td>{{ t.appealSuccessCount }}</td>
                <td>{{ t.appealRejectCount }}</td>
                <td>{{ t.uselessImageCount }}</td>
                <td>
                  {{
                    precisionFormat(
                      t.correctAnnoCount /
                        (t.correctAnnoCount + t.wrongAnnoCount + t.unnecessaryAnnoCount + t.omittedAnnoCount),
                    )
                  }}
                </td>
              </tr>
            </tbody>
            <thead v-if="adminTab === 'appr1'">
              <tr>
                <th>用户名</th>
                <th>角色</th>
                <th>正确框数</th>
                <th>修改框数</th>
                <!--                <th>添加&删除框数</th>-->
                <!--                <th>错误框数</th>-->
                <th>漏框</th>
                <th>改错框数</th>
                <th>申诉成功</th>
                <th>申诉失败</th>
                <th>无框图数</th>
                <th>准确率</th>
              </tr>
            </thead>
            <tbody v-if="adminTab === 'appr1'">
              <tr>
                <td>总计</td>
                <td>审核员</td>
                <td>{{ sumCalc(statListAdmin.approverOnes, 'correctAnnoCount') }}</td>
                <td>
                  {{
                    sumCalc(statListAdmin.approverOnes, 'updatedAnnoCount') +
                      sumCalc(statListAdmin.approverOnes, 'addedOrDeletedAnnoCount')
                  }}
                </td>
                <!--                <td>{{ sumCalc(statListAdmin.approverOnes, 'addedOrDeletedAnnoCount') }}</td>-->
                <!--                <td>{{ sumCalc(statListAdmin.approverOnes, 'wrongAnnoCount') }}</td>-->
                <td>{{ sumCalc(statListAdmin.approverOnes, 'wrongOmitAnnoCount') }}</td>
                <td>
                  {{
                    sumCalc(statListAdmin.approverOnes, 'wrongAnnoCount') -
                      sumCalc(statListAdmin.approverOnes, 'wrongOmitAnnoCount')
                  }}
                </td>
                <td>{{ sumCalc(statListAdmin.approverOnes, 'appealSuccessCount') }}</td>
                <td>{{ sumCalc(statListAdmin.approverOnes, 'appealRejectCount') }}</td>
                <td>{{ sumCalc(statListAdmin.approverOnes, 'uselessImageCount') }}</td>
                <td>
                  {{
                    precisionFormat(
                      (sumCalc(statListAdmin.approverOnes, 'correctAnnoCount') +
                        sumCalc(statListAdmin.approverOnes, 'updatedAnnoCount') +
                        sumCalc(statListAdmin.approverOnes, 'addedOrDeletedAnnoCount')) /
                        (sumCalc(statListAdmin.approverOnes, 'correctAnnoCount') +
                          sumCalc(statListAdmin.approverOnes, 'updatedAnnoCount') +
                          sumCalc(statListAdmin.approverOnes, 'addedOrDeletedAnnoCount') +
                          sumCalc(statListAdmin.approverOnes, 'wrongAnnoCount')),
                    )
                  }}
                </td>
              </tr>
              <tr v-for="(t, index) of statListAdmin.approverOnes" :key="`task${t.id}-${index}`">
                <td>{{ t.userName }}</td>
                <td>审核员</td>
                <td>{{ t.correctAnnoCount }}</td>
                <td>{{ t.updatedAnnoCount + t.addedOrDeletedAnnoCount }}</td>
                <!--                <td>{{ t.addedOrDeletedAnnoCount }}</td>-->
                <!--                <td>{{ t.wrongAnnoCount }}</td>-->
                <td>{{ t.wrongOmitAnnoCount }}</td>
                <td>{{ t.wrongAnnoCount - t.wrongOmitAnnoCount }}</td>
                <td>{{ t.appealSuccessCount }}</td>
                <td>{{ t.appealRejectCount }}</td>
                <td>{{ t.uselessImageCount }}</td>
                <td>
                  {{
                    precisionFormat(
                      (t.correctAnnoCount + t.updatedAnnoCount + t.addedOrDeletedAnnoCount) /
                        (t.correctAnnoCount + t.updatedAnnoCount + t.addedOrDeletedAnnoCount + t.wrongAnnoCount),
                    )
                  }}
                </td>
              </tr>
            </tbody>
            <thead v-if="adminTab === 'appr2'">
              <tr>
                <th>用户名</th>
                <th>角色</th>
                <th>正确框数</th>
                <th>修改框数</th>
                <!--                <th>添加&删除框数</th>-->
                <!--                <th>错误框数</th>-->
                <th>漏框</th>
                <th>改错框数</th>
                <th>无框图数</th>
                <th>准确率</th>
              </tr>
            </thead>
            <tbody v-if="adminTab === 'appr2'">
              <tr>
                <td>总计</td>
                <td>安检员</td>
                <td>{{ sumCalc(statListAdmin.approverTwos, 'correctAnnoCount') }}</td>
                <td>
                  {{
                    sumCalc(statListAdmin.approverTwos, 'updatedAnnoCount') +
                      sumCalc(statListAdmin.approverTwos, 'addedOrDeletedAnnoCount')
                  }}
                </td>
                <!--                <td>{{ sumCalc(statListAdmin.approverTwos, 'addedOrDeletedAnnoCount') }}</td>-->
                <!--                <td>{{ sumCalc(statListAdmin.approverTwos, 'wrongAnnoCount') }}</td>-->
                <td>{{ sumCalc(statListAdmin.approverTwos, 'wrongOmitAnnoCount') }}</td>
                <td>
                  {{
                    sumCalc(statListAdmin.approverTwos, 'wrongAnnoCount') -
                      sumCalc(statListAdmin.approverTwos, 'wrongOmitAnnoCount')
                  }}
                </td>
                <td>{{ sumCalc(statListAdmin.approverTwos, 'uselessImageCount') }}</td>
                <td>
                  {{
                    precisionFormat(
                      (sumCalc(statListAdmin.approverTwos, 'correctAnnoCount') +
                        sumCalc(statListAdmin.approverTwos, 'updatedAnnoCount') +
                        sumCalc(statListAdmin.approverTwos, 'addedOrDeletedAnnoCount')) /
                        (sumCalc(statListAdmin.approverTwos, 'correctAnnoCount') +
                          sumCalc(statListAdmin.approverTwos, 'updatedAnnoCount') +
                          sumCalc(statListAdmin.approverTwos, 'addedOrDeletedAnnoCount') +
                          sumCalc(statListAdmin.approverTwos, 'wrongAnnoCount')),
                    )
                  }}
                </td>
              </tr>
              <tr v-for="(t, index) of statListAdmin.approverTwos" :key="`task${t.id}-${index}`">
                <td>{{ t.userName }}</td>
                <td>安检员</td>
                <td>{{ t.correctAnnoCount }}</td>
                <td>{{ t.updatedAnnoCount + t.addedOrDeletedAnnoCount }}</td>
                <!--                <td>{{ t.addedOrDeletedAnnoCount }}</td>-->
                <!--                <td>{{ t.wrongAnnoCount }}</td>-->
                <td>{{ t.wrongOmitAnnoCount }}</td>
                <td>{{ t.wrongAnnoCount - t.wrongOmitAnnoCount }}</td>
                <td>{{ t.uselessImageCount }}</td>
                <td>
                  {{
                    precisionFormat(
                      (t.correctAnnoCount + t.updatedAnnoCount + t.addedOrDeletedAnnoCount) /
                        (t.correctAnnoCount + t.updatedAnnoCount + t.addedOrDeletedAnnoCount + t.wrongAnnoCount),
                    )
                  }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div v-if="listTab === 'cat' && !showTask" style="overflow: auto">
        <table width="100%" class="table">
          <thead>
            <tr>
              <th v-for="(catName, index) of catList.map(v => v.className)" :key="`catName${index}`">{{ catName }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td v-for="cat of catList" :key="`cat${cat.classId}`">{{ cat.count }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <!--显示图片统计信息-->
      <div v-if="listTab === 'image' && !showTask">
        <div class="title">图片宽度统计</div>
        <div>
          <ve-histogram :data="imageStatisticInfo.width" :extend="extend"></ve-histogram>
        </div>
        <div class="title">图片高度统计</div>
        <div>
          <ve-histogram :data="imageStatisticInfo.height" :extend="extend"></ve-histogram>
        </div>
        <div class="title">图片宽高比统计</div>
        <div>
          <ve-histogram :data="imageStatisticInfo.imgRatio" :extend="extend"></ve-histogram>
        </div>
        <div class="title">图片面积统计</div>
        <div>
          <ve-histogram :data="imageStatisticInfo.area" :extend="extend"></ve-histogram>
        </div>
        <div class="title">标注宽度统计</div>
        <div>
          <ve-histogram :data="imageStatisticInfo.bboxWidth" :extend="extend"></ve-histogram>
        </div>
        <div class="title">标注高度统计</div>
        <div>
          <ve-histogram :data="imageStatisticInfo.bboxHeight" :extend="extend"></ve-histogram>
        </div>
        <div class="title">标注宽高比统计</div>
        <div>
          <ve-histogram :data="imageStatisticInfo.bboxRatio" :extend="extend"></ve-histogram>
        </div>
        <div class="title">标注面积统计</div>
        <div>
          <ve-histogram :data="imageStatisticInfo.bboxArea" :extend="extend"></ve-histogram>
        </div>
        <div class="title">标注归一化宽度统计</div>
        <div>
          <ve-histogram :data="imageStatisticInfo.normalizeWidth" :extend="extend"></ve-histogram>
        </div>
        <div class="title">标注归一化高度统计</div>
        <div>
          <ve-histogram :data="imageStatisticInfo.normalizeHeight" :extend="extend"></ve-histogram>
        </div>
        <div class="title">标注归一化面积统计</div>
        <div>
          <ve-histogram :data="imageStatisticInfo.normalizeArea" :extend="extend"></ve-histogram>
        </div>
      </div>
      <!--任务类别确认弹出框-->
      <el-dialog title="选择类别" :visible.sync="classConfirmVisible">
        <el-tree
          :data="defaultClassList"
          show-checkbox
          node-key="id"
          :default-expanded-keys="defaultExpandedKeys"
          :default-checked-keys="defaultCheckedKeys"
          :props="defaultProps"
          ref="tree"
        >
        </el-tree>
        <div slot="footer" class="dialog-footer">
          <el-button @click="classConfirmVisible = false">取 消</el-button>
          <el-button type="primary" @click="getImageStatistic">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import * as api from '@/api/api.js';
import navigation from '@/components/navigation';
import Decimal from 'decimal.js';
import JsonExcel from 'vue-json-excel';
import { taskStatusMap, classificationObj } from '@/config';
import moment from 'moment';

export default {
  data: function() {
    return {
      listTab: 'task',
      allTaskList: [], // 所有的任务列表
      filterTaskList: [], // 检索得到的任务列表
      taskIds: [],
      catList: [],
      showTask: true,
      statList: [],
      statTaskList: [],
      statListAdmin: {},
      role: '',
      userList: [],
      adminTab: 'anno',
      enAble: true,
      taskAnnoSalary: {},
      fields: {
        anno: {
          用户名: 'userName',
          角色: 'role',
          正确框数: 'correctAnnoCount',
          错误框数: 'wrongAnnoCount',
          多框数: 'unnecessaryAnnoCount',
          漏框数: 'omittedAnnoCount',
          申诉成功: 'appealSuccessCount',
          申诉失败: 'appealRejectCount',
          无框图数: 'uselessImageCount',
          准确率: 'correctRate',
        },
        appr1: {
          用户名: 'userName',
          角色: 'role',
          正确框数: 'correctAnnoCount',
          修改框数: 'modifiedAnnoCount',
          漏框: 'wrongOmitAnnoCount',
          改错框数: 'wrongModifiedAnnoCount',
          申诉成功: 'appealSuccessCount',
          申诉失败: 'appealRejectCount',
          无框图数: 'uselessImageCount',
          准确率: 'correctRate',
        },
        appr2: {
          用户名: 'userName',
          角色: 'role',
          正确框数: 'correctAnnoCount',
          修改框数: 'modifiedAnnoCount',
          漏框: 'wrongOmitAnnoCount',
          改错框数: 'wrongModifiedAnnoCount',
          无框图数: 'uselessImageCount',
          准确率: 'correctRate',
        },
      },
      jsonData: [],
      excelName: '',
      taskStatusMap: {},
      taskName: '',
      taskStatusList: [],
      timeRange: [new Date('2020-10-1'), new Date(new Date().toLocaleDateString()).getTime()],
      isIndeterminate: false, // 控制样式
      checkAll: false,
      classList: [],
      classConfirmVisible: false,
      defaultClassList: [
        {
          id: 1,
          label: 'A类',
          children: [],
        },
        {
          id: 2,
          label: 'B类',
          children: [],
        },
        {
          id: 3,
          label: 'C类',
          children: [],
        },
        {
          id: 4,
          label: '其他',
          children: [],
        },
      ],
      defaultProps: {
        children: 'children',
        label: 'label',
      },
      defaultExpandedKeys: [],
      defaultCheckedKeys: [],
      imageStatisticInfo: {},
      extend: {
        series: {
          label: { show: true, position: 'top' },
        },
      },
      loading: null,
    };
  },
  components: {
    navigation,
    JsonExcel,
  },
  computed: {
    annotatorSalary: function() {
      return function(task) {
        return Decimal(task.correctAnnoCount)
          .mul(this.taskAnnoSalary[task.id].annotatorCorrect)
          .add(Decimal(task.unnecessaryAnnoCount).mul(this.taskAnnoSalary[task.id].annotatorUnnecessary))
          .add(Decimal(task.omittedAnnoCount).mul(this.taskAnnoSalary[task.id].annotatorOmit))
          .add(Decimal(task.wrongAnnoCount).mul(this.taskAnnoSalary[task.id].annotatorWrong))
          .add(Decimal(task.uselessImageCount).mul(this.taskAnnoSalary[task.id].annotatorUseless))
          .add(Decimal(task.appealSuccessCount).mul(this.taskAnnoSalary[task.id].annotatorAppealSuccess))
          .add(Decimal(task.appealRejectCount).mul(this.taskAnnoSalary[task.id].annotatorAppealReject));
      };
    },
    approverTwoSalary: function() {
      return function(task) {
        return Decimal(task.correctAnnoCount)
          .mul(this.taskAnnoSalary[task.id].approverTwoCorrect)
          .add(
            Decimal(task.updatedAnnoCount)
              .add(task.addedOrDeletedAnnoCount)
              .mul(this.taskAnnoSalary[task.id].approverTwoUpdateCorrect),
          )
          .add(Decimal(task.wrongOmitAnnoCount).mul(this.taskAnnoSalary[task.id].approverTwoOmit))
          .add(
            Decimal(task.wrongAnnoCount)
              .sub(task.wrongOmitAnnoCount)
              .mul(this.taskAnnoSalary[task.id].approverTwoUpdateWrong),
          )
          .add(Decimal(task.uselessImageCount).mul(this.taskAnnoSalary[task.id].approverTwoUseless));
      };
    },
    createDate: function() {
      return function(createAt) {
        return moment(createAt * 1000).format('YYYY/MM/DD');
      };
    },
  },
  mounted: function() {
    this.getTaskListForSalary();
    this.role = this.$store.state.role;
    this.taskStatusMap = taskStatusMap;
    if (this.role === 'admin') {
      api
        .getUserList({ p: 0, s: 9999, stat: -1 })
        .then(res => {
          this.userList = res.data.users;
        })
        .catch(() => {});
      this.getUserTotalClasses();
    }
  },
  beforeDestroy() {
    this.$nprogress.done();
  },
  methods: {
    toRank() {
      this.$router.push({ path: '/rank' });
    },
    sumCalc(data, key) {
      let sum = data.reduce((t, i) => (t += i[key]), 0);
      return sum;
    },
    precisionFormat(value) {
      if (isNaN(value)) {
        return '0%';
      }
      return (value * 100).toFixed(2).toString() + '%';
    },
    getTaskListForSalary() {
      api
        .getTaskListForSalary()
        .then(res => {
          this.allTaskList = [];
          this.allTaskList = res.data.map(v => {
            return {
              ...v,
              createAt: moment(v.createAt).unix(),
              updateAt: moment(v.updateAt).unix(),
            };
          });
          this.allTaskList.sort((a, b) => b.id - a.id);
          this.filterTaskList = [...this.allTaskList];
          // if (this.filterTaskList.length > 0) this.queryTaskId = this.filterTaskList[0].id;
        })
        .catch(() => {});
    },
    getStatSalary() {
      if (!this.taskIds.length) {
        this.$message.warning('请至少选择一个任务');
        return;
      }
      if (this.enAble) {
        this.$nprogress.start();
        this.$message({
          type: 'success',
          message: '正在获取统计数据',
          duration: 1000,
        });
        this.enAble = false;
        this.getTaskAnnoSalary();
        this.getTaskSalary();
      }
    },
    getStatCat() {
      api
        .getStatCat(this.taskIds)
        .then(res => {
          this.showTask = false;
          this.listTab = 'cat';
          this.catList = res.data;
        })
        .catch(err => {
          window.console.log(err);
        });
    },
    getData(data) {
      this.statTaskList = data.map(d => {
        return {
          taskName: this.filterTaskList.find(v => v.id === d.task.id).name,
          correctAnnoCount: d.correctAnnoCount,
          wrongAnnoCount: d.wrongAnnoCount,
          unnecessaryAnnoCount: d.unnecessaryAnnoCount,
          omittedAnnoCount: d.omittedAnnoCount,
          uselessImageCount: d.uselessImageCount,
          addedOrDeletedAnnoCount: d.addedOrDeletedAnnoCount,
          updatedAnnoCount: d.updatedAnnoCount,
          appealSuccessCount: d.appealSuccessCount,
          appealRejectCount: d.appealRejectCount,
          wrongOmitAnnoCount: d.wrongOmitAnnoCount,
          id: d.id,
        };
      });
    },
    getDataAdmin(data) {
      this.statListAdmin.annotators = data.annotators.map(d => {
        Object.assign(d, { userName: this.userList.find(v => v.userId === d.userId).userName });
        return d;
      });
      this.statListAdmin.approverOnes = data.approverOnes.map(d => {
        Object.assign(d, { userName: this.userList.find(v => v.userId === d.userId).userName });
        return d;
      });
      this.statListAdmin.approverTwos = data.approverTwos.map(d => {
        Object.assign(d, { userName: this.userList.find(v => v.userId === d.userId).userName });
        return d;
      });
    },
    getTaskAnnoSalary() {
      api.getTaskAnnoSalary({ tids: this.taskIds.join(',') }).then(res => {
        this.taskAnnoSalary = res.data;
      });
    },
    async getTaskSalary() {
      let count = 0;
      const total = Math.ceil(this.taskIds.length / 6);
      let data = [];
      const annotator = {};
      const approverOne = {};
      const approverTwo = {};
      const adminObj = {
        annotators: [],
        approverOnes: [],
        approverTwos: [],
      };
      while (count < total) {
        const res = await api.getStatSalary(this.taskIds.slice(count * 6, (count + 1) * 6)).catch(err => err);
        if (!res.data) {
          this.enAble = true;
          this.$message.error('获取统计信息失败');
          this.$nprogress.done();
          return;
        } else {
          const result = res.data;
          if (this.role === 'admin') {
            result.annotators.forEach(v => {
              const index = annotator[v.userId];
              if (index >= 0) {
                adminObj.annotators[index].appealRejectCount =
                  (adminObj.annotators[index].appealRejectCount || 0) + v.appealRejectCount;
                adminObj.annotators[index].appealSuccessCount =
                  (adminObj.annotators[index].appealSuccessCount || 0) + v.appealSuccessCount;
                adminObj.annotators[index].correctAnnoCount =
                  (adminObj.annotators[index].correctAnnoCount || 0) + v.correctAnnoCount;
                adminObj.annotators[index].omittedAnnoCount =
                  (adminObj.annotators[index].omittedAnnoCount || 0) + v.omittedAnnoCount;
                adminObj.annotators[index].unnecessaryAnnoCount =
                  (adminObj.annotators[index].unnecessaryAnnoCount || 0) + v.unnecessaryAnnoCount;
                adminObj.annotators[index].uselessImageCount =
                  (adminObj.annotators[index].uselessImageCount || 0) + v.uselessImageCount;
                adminObj.annotators[index].wrongAnnoCount =
                  (adminObj.annotators[index].wrongAnnoCount || 0) + v.wrongAnnoCount;
              } else {
                adminObj.annotators.push(v);
                annotator[v.userId] = adminObj.annotators.length - 1;
              }
            });
            result.approverOnes.forEach(v => {
              const index = approverOne[v.userId];
              if (index >= 0) {
                adminObj.approverOnes[index].addedOrDeletedAnnoCount =
                  (adminObj.approverOnes[index].addedOrDeletedAnnoCount || 0) + v.addedOrDeletedAnnoCount;
                adminObj.approverOnes[index].appealRejectCount =
                  (adminObj.approverOnes[index].appealRejectCount || 0) + v.appealRejectCount;
                adminObj.approverOnes[index].appealSuccessCount =
                  (adminObj.approverOnes[index].appealSuccessCount || 0) + v.appealSuccessCount;
                adminObj.approverOnes[index].correctAnnoCount =
                  (adminObj.approverOnes[index].correctAnnoCount || 0) + v.correctAnnoCount;
                adminObj.approverOnes[index].updatedAnnoCount =
                  (adminObj.approverOnes[index].updatedAnnoCount || 0) + v.updatedAnnoCount;
                adminObj.approverOnes[index].uselessImageCount =
                  (adminObj.approverOnes[index].uselessImageCount || 0) + v.uselessImageCount;
                adminObj.approverOnes[index].wrongAnnoCount =
                  (adminObj.approverOnes[index].wrongAnnoCount || 0) + v.wrongAnnoCount;
                adminObj.approverOnes[index].wrongOmitAnnoCount =
                  (adminObj.approverOnes[index].wrongOmitAnnoCount || 0) + v.wrongOmitAnnoCount;
              } else {
                adminObj.approverOnes.push(v);
                approverOne[v.userId] = adminObj.approverOnes.length - 1;
              }
            });
            result.approverTwos.forEach(v => {
              const index = approverTwo[v.userId];
              if (index >= 0) {
                adminObj.approverTwos[index].addedOrDeletedAnnoCount =
                  (adminObj.approverTwos[index].addedOrDeletedAnnoCount || 0) + v.addedOrDeletedAnnoCount;
                adminObj.approverTwos[index].correctAnnoCount =
                  (adminObj.approverTwos[index].correctAnnoCount || 0) + v.correctAnnoCount;
                adminObj.approverTwos[index].updatedAnnoCount =
                  (adminObj.approverTwos[index].updatedAnnoCount || 0) + v.updatedAnnoCount;
                adminObj.approverTwos[index].uselessImageCount =
                  (adminObj.approverTwos[index].uselessImageCount || 0) + v.uselessImageCount;
                adminObj.approverTwos[index].wrongAnnoCount =
                  (adminObj.approverTwos[index].wrongAnnoCount || 0) + v.wrongAnnoCount;
                adminObj.approverTwos[index].wrongOmitAnnoCount =
                  (adminObj.approverTwos[index].wrongOmitAnnoCount || 0) + v.wrongOmitAnnoCount;
              } else {
                adminObj.approverTwos.push(v);
                approverTwo[v.userId] = adminObj.approverTwos.length - 1;
              }
            });
          } else {
            data = data.concat(result);
          }
        }
        count += 1;
      }
      this.enAble = true;
      this.showTask = false;
      this.listTab = 'task';
      if (this.role === 'admin') this.getDataAdmin(adminObj);
      else this.getData(data);
      this.$message.success('统计信息获取成功');
      this.$nprogress.done();
      // api.getStatSalary(this.taskIds);
      // api
      //   .getStatSalary(this.taskIds)
      //   .then(res => {
      //     this.showTask = false;
      //     this.listTab = 'task';
      //     if (this.role === 'admin') this.getDataAdmin(res.data);
      //     else this.getData(res.data);
      //     this.enAble = true;
      //   })
      //   .catch(err => {
      //     this.enAble = true;
      //     window.console.log(err);
      //   });
    },
    exportData() {
      this.jsonData = [];
      if (this.adminTab === 'anno') {
        this.excelName = '标注员统计信息';
        this.jsonData = this.statListAdmin.annotators.map(v => {
          return {
            userName: v.userName,
            appealRejectCount: v.appealRejectCount,
            appealSuccessCount: v.appealSuccessCount,
            correctAnnoCount: v.correctAnnoCount,
            omittedAnnoCount: v.omittedAnnoCount,
            unnecessaryAnnoCount: v.unnecessaryAnnoCount,
            uselessImageCount: v.uselessImageCount,
            wrongAnnoCount: v.wrongAnnoCount,
            role: '标注员',
            correctRate: this.precisionFormat(
              v.correctAnnoCount /
                (v.correctAnnoCount + v.wrongAnnoCount + v.unnecessaryAnnoCount + v.omittedAnnoCount),
            ),
          };
        });
      } else if (this.adminTab === 'appr1') {
        this.excelName = '审核员统计信息';
        this.jsonData = this.statListAdmin.approverOnes.map(v => {
          return {
            userName: v.userName,
            appealRejectCount: v.appealRejectCount,
            appealSuccessCount: v.appealSuccessCount,
            modifiedAnnoCount: v.updatedAnnoCount + v.addedOrDeletedAnnoCount,
            correctAnnoCount: v.correctAnnoCount,
            updatedAnnoCount: v.updatedAnnoCount,
            wrongOmitAnnoCount: v.wrongOmitAnnoCount,
            wrongModifiedAnnoCount: v.wrongAnnoCount - v.wrongOmitAnnoCount,
            uselessImageCount: v.uselessImageCount,
            wrongAnnoCount: v.wrongAnnoCount,
            addedOrDeletedAnnoCount: v.addedOrDeletedAnnoCount,
            role: '审核员',
            correctRate: this.precisionFormat(
              (v.correctAnnoCount + v.updatedAnnoCount + v.addedOrDeletedAnnoCount) /
                (v.correctAnnoCount + v.updatedAnnoCount + v.addedOrDeletedAnnoCount + v.wrongAnnoCount),
            ),
          };
        });
      } else if (this.adminTab === 'appr2') {
        this.excelName = '安检员统计信息';
        this.jsonData = this.statListAdmin.approverTwos.map(v => {
          return {
            userName: v.userName,
            correctAnnoCount: v.correctAnnoCount,
            modifiedAnnoCount: v.updatedAnnoCount + v.addedOrDeletedAnnoCount,
            updatedAnnoCount: v.updatedAnnoCount,
            uselessImageCount: v.uselessImageCount,
            wrongAnnoCount: v.wrongAnnoCount,
            wrongOmitAnnoCount: v.wrongOmitAnnoCount,
            wrongModifiedAnnoCount: v.wrongAnnoCount - v.wrongOmitAnnoCount,
            addedOrDeletedAnnoCount: v.addedOrDeletedAnnoCount,
            role: '安检员',
            correctRate: this.precisionFormat(
              (v.correctAnnoCount + v.updatedAnnoCount + v.addedOrDeletedAnnoCount) /
                (v.correctAnnoCount + v.updatedAnnoCount + v.addedOrDeletedAnnoCount + v.wrongAnnoCount),
            ),
          };
        });
      }
    },
    filterTask() {
      this.filterTaskList = this.allTaskList.filter(v => {
        if (this.taskName && !v.name.includes(this.taskName)) return false;
        if (this.taskStatusList.length && !this.taskStatusList.includes(v.status.toString())) return false;
        if (!(moment(this.timeRange[0]).unix() <= v.createAt && v.createAt < moment(this.timeRange[1]).unix() + 86400))
          return false;
        return true;
      });
    },
    handleCheckAllChange(value) {
      this.taskIds = value ? this.filterTaskList.map(v => v.id) : [];
      this.isIndeterminate = false;
    },
    handleCheckedTaskChange() {
      this.checkAll = this.taskIds.length === this.filterTaskList.length;
      this.isIndeterminate = this.taskIds.length > 0 && this.taskIds.length < this.filterTaskList.length;
    },
    getTaskClass() {
      if (this.taskIds.length === 0) {
        this.$message.warning('请先选择任务');
        return;
      }
      this.defaultClassList[0].children = [];
      this.defaultClassList[1].children = [];
      this.defaultClassList[2].children = [];
      this.defaultClassList[3].children = [];
      this.classList.forEach(v => {
        if (classificationObj['A'].includes(v.id)) {
          this.defaultClassList[0].children.push({
            id: v.id,
            label: v.name,
          });
        } else if (classificationObj['B'].includes(v.id)) {
          this.defaultClassList[1].children.push({
            id: v.id,
            label: v.name,
          });
        } else if (classificationObj['C'].includes(v.id)) {
          this.defaultClassList[2].children.push({
            id: v.id,
            label: v.name,
          });
        } else {
          this.defaultClassList[3].children.push({
            id: v.id,
            label: v.name,
          });
        }
      });
      this.defaultCheckedKeys = this.filterTaskList.reduce((last, cur) => {
        if (this.taskIds.includes(cur.id)) {
          last.push(...cur.classIds);
          last = [...new Set(last)];
        }
        return last;
      }, []);
      this.defaultExpandedKeys = this.defaultCheckedKeys.reduce((last, cur) => {
        if (classificationObj['A'].includes(cur)) {
          if (!last.includes(1)) last.push(1);
        } else if (classificationObj['B'].includes(cur)) {
          if (!last.includes(2)) last.push(2);
        } else if (classificationObj['C'].includes(cur)) {
          if (!last.includes(3)) last.push(3);
        } else {
          if (!last.includes(4)) last.push(4);
        }
        return last;
      }, []);
      this.$nextTick(() => {
        this.$refs.tree.setCheckedKeys(this.defaultCheckedKeys);
      });
      this.classConfirmVisible = true;
    },
    getUserTotalClasses() {
      api.getUserTotalClassesNew().then(res => {
        this.classList = res.data.classifications;
      });
    },
    getImageStatistic() {
      api
        .getImageStatistic({
          taskIds: this.taskIds,
          classIds: this.$refs.tree.getCheckedKeys(),
          bucket: 10,
        })
        .then(res => {
          this.listTab = 'image';
          this.showTask = false;
          this.classConfirmVisible = false;
          this.imageStatisticInfo = {};
          const result = res.data;
          Object.keys(result).map(v => {
            this.imageStatisticInfo[v] = {
              columns: ['xCoordinate', 'count'],
              rows: result[v],
            };
          });
        });
    },
  },
};
</script>
<style scoped>
p {
  margin: 0px;
}
table {
  border-collapse: collapse;
  margin: 0px;
  text-align: left;
  font-size: 14px;
  margin-top: 18px;
}
table th,
table td {
  padding-left: 24px;
}
table thead tr {
  height: 54px;
  font-weight: 500;
  background: #fafafa;
}
table tr {
  border-bottom: 1px solid #eeeeee;
  height: 54px;
}
table tbody {
  color: #595959;
}
select {
  width: 110px;
  height: 33px;
  appearance: none;
  background-image: url('~@/assets/select-arrow.png');
  background-repeat: no-repeat;
  background-position: 90%;
  background-size: 14px;
  background-color: #fafafa;
  color: #595959;
  padding: 9px 12px;
  font-size: 14px;
  line-height: 100%;
  outline: none;
  border-radius: 4px;
  border: 1px solid #dddddd;
}
button {
  height: 33px;
  vertical-align: top;
  margin-right: 18px;
}
.title {
  font-size: 20px;
  font-weight: 700;
  text-align: center;
  color: #5d89c0;
}
</style>
